import mergeAll from "ramda/es/mergeAll";
import * as routing from './router';
export const routingSlice = mergeAll([
    routing
].map(({ defaultSlice })=>defaultSlice));
